// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-container {
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: 60px;
  max-width: 1600px;
  margin: auto;
  background-color: #f1f1f1;
  box-sizing: border-box;
}

.card-header {
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
  color: #333;
  background-color: #f1f1f1;
  padding: 10px 20px;
  z-index: 1;
}

.card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  text-align: left;
  transition: transform 0.3s, box-shadow 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;
}

.card:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.card-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin-bottom: 10px;
}

.card-title {
  font-size: 18px;
  color: #0ec4e4;
  margin-bottom: 5px;
}

.card-description {
  font-size: 14px;
  color: #666;
  text-align: center;
}

@media (max-width: 768px) {
  .grid-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 45px;
  }

  .card {
    padding: 15px;
  }

  .card-title {
    font-size: 16px;
  }

  .card-description {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .grid-container {
    grid-template-columns: 1fr;
    padding: 95px 80px;
  }

  .card-header {
    margin-top: 30px;
    font-size: 1.5rem;
    padding: 8px 16px;
  }

  .card {
    width: 95%;
    margin: 0 auto;
    padding: 10px;
  }

  .card-title {
    font-size: 14px;
  }

  .card-description {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CardLayout/CardLayout.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,gBAAgB;EAChB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,cAAc;IACd,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".grid-container {\n  position: relative;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  padding: 60px;\n  max-width: 1600px;\n  margin: auto;\n  background-color: #f1f1f1;\n  box-sizing: border-box;\n}\n\n.card-header {\n  position: absolute;\n  top: -25px;\n  left: 50%;\n  transform: translateX(-50%);\n  text-align: center;\n  font-size: 2rem;\n  font-weight: bold;\n  color: #333;\n  background-color: #f1f1f1;\n  padding: 10px 20px;\n  z-index: 1;\n}\n\n.card {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  text-align: left;\n  transition: transform 0.3s, box-shadow 0.3s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 20px;\n}\n\n.card:hover {\n  transform: scale(1.05);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.card-image {\n  width: 80px;\n  height: 80px;\n  object-fit: cover;\n  margin-bottom: 10px;\n}\n\n.card-title {\n  font-size: 18px;\n  color: #0ec4e4;\n  margin-bottom: 5px;\n}\n\n.card-description {\n  font-size: 14px;\n  color: #666;\n  text-align: center;\n}\n\n@media (max-width: 768px) {\n  .grid-container {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 45px;\n  }\n\n  .card {\n    padding: 15px;\n  }\n\n  .card-title {\n    font-size: 16px;\n  }\n\n  .card-description {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .grid-container {\n    grid-template-columns: 1fr;\n    padding: 95px 80px;\n  }\n\n  .card-header {\n    margin-top: 30px;\n    font-size: 1.5rem;\n    padding: 8px 16px;\n  }\n\n  .card {\n    width: 95%;\n    margin: 0 auto;\n    padding: 10px;\n  }\n\n  .card-title {\n    font-size: 14px;\n  }\n\n  .card-description {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
